import {
  ROLES_FETCHING,
  ROLES_SUCCESS,
  ROLES_ADD_SUCCESS,
  ROLES_ADD_FAILED,
  ROLES_EDIT_SUCCESS,
  ROLES_EDIT_FAILED,
  ROLES_DELETE_SUCCESS,
  ROLES_DELETE_FAILED,
  ROLES_FAILED,
  ROLES_FIND_BY_ID,
  ROLES_CLEAR,
  } from "../services/Constants";
  import { Roles } from "../types/roles.type";
    
    export interface RolesState {
        result: Roles[];
        isFetching: boolean;
        isError: boolean;
        isAdddata: boolean,
        isEditdata: boolean,
        isAddError: boolean;
        isEditError: boolean;
        isDeletedata: boolean;
        isDeleteError: boolean;
        result_by_id: any;
    }
    
    const initialState: RolesState = {
        result: [],
        isFetching: false,
        isError: false,
        isAdddata: false,
        isEditdata: false,
        isAddError: false,
        isEditError: false,
        isDeletedata: false,
        isDeleteError: false,
        result_by_id: null,
    };
    
    export default (state = initialState, { type, payload}: any) => {
      switch (type) {
        case ROLES_FETCHING:
          return { ...state, result: [], isFetching: true,isAdddata: false,isEditdata: false, 
            isError: false,isAddError: false,isEditError: false,isDeletedata: false,isDeleteError: false};
        case ROLES_SUCCESS:
          return { 
            ...state, 
            result: payload,
            isFetching: false,
            isAdddata: false,
            isEditdata: false,
            isError: false,
            isAddError: false,
            isEditError: false,
            isDeletedata: false,
            isDeleteError: false
          };
          case ROLES_ADD_SUCCESS:
          return { 
            ...state, 
            isFetching: false,
            isAdddata: true,
            isEditdata: false, 
            isError: false,
            isAddError: false,
            isEditError: false,
            isDeletedata: false,
            isDeleteError: false
          };
          case ROLES_EDIT_SUCCESS:
          return { 
            ...state, 
            isFetching: false, 
            isAdddata: false,
            isEditdata: true, 
            isError: false,
            isAddError: false,
            isEditError: false,
            isDeletedata: false,
            isDeleteError: false
          };
        case ROLES_FAILED:
          return { ...state, result: [], isFetching: false,isAdddata: false,isEditdata: false,
             isError: true,isAddError: false,isEditError: false,isDeletedata: false,isDeleteError: false};
        case ROLES_ADD_FAILED:
          return { ...state, result: [], isFetching: false,isAdddata: false,isEditdata: false,
             isError: false,isAddError: true,isEditError: false,isDeletedata: false,isDeleteError: false};
          case ROLES_EDIT_FAILED:
          return { ...state, result: [], isFetching: false,isAdddata: false,isEditdata: false, 
            isError: false,isAddError: false,isEditError: true,isDeletedata: false,isDeleteError: false};
            case ROLES_DELETE_SUCCESS:
          return { ...state, result: [], isFetching: false,isAdddata: false,isEditdata: false, 
            isError: false,isAddError: false,isEditError: false,isDeletedata: true,isDeleteError: false};
            case ROLES_DELETE_FAILED:
          return { ...state, result: [], isFetching: false,isAdddata: false,isEditdata: false, 
            isError: false,isAddError: false,isEditError: false,isDeletedata: false,isDeleteError: true};
            case ROLES_FIND_BY_ID:
          return { ...state, result_by_id: payload };
        default:
          return state;
      }
      
    };
    